import { Icon, type IconDefinition } from '@vrplatform/icons';
import type { ThemeColor } from '@vrplatform/theme';
import { Text, useMantineTheme } from '@mantine/core';
import { Box, Title } from '@mantine/core';
import type { ReactNode } from 'react';

type Props = {
  title: string;
  description: string;
  icon: IconDefinition;
  iconColor?: ThemeColor | (string & {}) | 'primary';
  iconSize?: number;
  contentMaxWidth?: number;
  children?: ReactNode;
  backgroundColor?: string;
};

export const ViewPlaceholder = ({
  description,
  title,
  children,
  contentMaxWidth = 500,
  icon,
  iconColor,
  iconSize = 30,
  backgroundColor,
}: Props) => {
  const { primaryColor } = useMantineTheme();

  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: backgroundColor ?? theme.colors.gray[0],
        borderRadius: theme.radius.sm,
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        minHeight: 400,
      })}
    >
      <Box
        sx={() => ({
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: contentMaxWidth,
          textAlign: 'center',
        })}
      >
        <Icon
          icon={icon}
          size={iconSize}
          color={(theme) => {
            if (iconColor) {
              const themeColor =
                theme.colors[
                  iconColor === 'primary' ? primaryColor : iconColor
                ];

              if (themeColor) return themeColor[6];
              return iconColor;
            }

            return theme.colors.neutral[8];
          }}
        />
        <Title order={4} mt="lg" mb="xs">
          {title}
        </Title>
        <Text component="p" c="neutral" mb={children ? 'lg' : undefined}>
          {description}
        </Text>
        {children}
      </Box>
    </Box>
  );
};
